// Firebase configuration for client
// @ts-ignore
import { initializeApp } from 'firebase/app';
// @ts-ignore  
import { getFirestore } from 'firebase/firestore';
// @ts-ignore
import { getStorage } from 'firebase/storage';

// Environment-based configuration
// In development: reads from .env.development
// In production: reads from Netlify environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate configuration - fail fast if missing
if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.storageBucket) {
  const errorMsg = [
    '❌ Missing Firebase configuration!',
    '',
    'Required environment variables:',
    '  - REACT_APP_FIREBASE_API_KEY',
    '  - REACT_APP_FIREBASE_PROJECT_ID', 
    '  - REACT_APP_FIREBASE_STORAGE_BUCKET',
    '  - REACT_APP_FIREBASE_AUTH_DOMAIN',
    '  - REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    '  - REACT_APP_FIREBASE_APP_ID',
    '',
    'For local development:',
    '  1. Copy .env.development file in client/ folder',
    '  2. Fill in your dev Firebase credentials',
    '  3. Restart the development server',
    '',
    'For production:',
    '  1. Set environment variables in Netlify dashboard',
    '  2. Use production Firebase credentials',
  ].join('\n');
  
  console.error(errorMsg);
  throw new Error('Firebase configuration missing. See console for details.');
}

// Environment indicator
const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
const isDevelopment = environment === 'development';

// Log configuration (helpful for debugging)
console.log(`🔥 Firebase initialized for: ${environment.toUpperCase()}`);
console.log(`📁 Project: ${firebaseConfig.projectId}`);

if (isDevelopment) {
  console.log('⚠️  DEVELOPMENT MODE - Using dev Firebase project');
  console.log('💡 Location:', window.location.origin);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export environment info for debugging
export const firebaseEnv = {
  environment,
  isDevelopment,
  projectId: firebaseConfig.projectId
};

export default app;